import { memo, useState } from "react";
import { IconButton, TableRow } from "@mui/material";
import { GridMoreVertIcon } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";

import {
  StyledTableCell,
  StyledTableMenuCell,
} from "../../../../../common/components/functional/simpleTable/styled";
import { ActionMenu } from "./ActionMenu";
import {
  formatCellValue,
  SimpleTableCell,
  SimpleTableDataCell,
  SimpleTableDataLinkCell,
} from "../../../../../common/components/functional/simpleTable/cellHelpers";

interface Props {
  onApprove: (id: string) => void;
  onRemoveApproval: (id: string) => void;
  onDelete: (id: string) => void;
  isUserAllowedToDelete: boolean;
  editRow?: (payslipId: string) => void;
  rowId: string;
  row: SimpleTableCell[];
  isUserAllowedToEdit: boolean;
  openConfirmationDialog: (id: string) => void;
}

const PayslipRowItem = ({
  onApprove,
  onRemoveApproval,
  onDelete,
  isUserAllowedToDelete,
  editRow,
  row,
  rowId,
  isUserAllowedToEdit,
  openConfirmationDialog,
}: Props) => {
  const { t } = useTranslation();

  const [actionMenuAnchor, setActionMenuAnchor] = useState<null | HTMLElement>(
    null,
  );

  const askForConfirmation = () => {
    openConfirmationDialog(rowId);
  };

  return (
    <>
      <TableRow>
        {row.map((field, i) => {
          return field.type !== "link" ? (
            <SimpleTableDataCell
              key={i}
              width={field.width}
              value={
                field.type !== "key"
                  ? formatCellValue(field)
                  : t("talentProfile:" + field.value)
              }
              color={field.color}
            />
          ) : (
            <SimpleTableDataLinkCell
              key={i}
              value={field.value}
              width={field.width}
              onClick={field.onClick}
              component={field.component}
              LinkProps={field.linkProps}
            />
          );
        })}
        {isUserAllowedToEdit ? (
          <>
            <StyledTableMenuCell>
              <IconButton onClick={(e) => setActionMenuAnchor(e.currentTarget)}>
                <GridMoreVertIcon />
              </IconButton>
            </StyledTableMenuCell>

            <ActionMenu
              open={!!actionMenuAnchor}
              anchorEl={actionMenuAnchor}
              onClose={() => setActionMenuAnchor(null)}
              payslipId={rowId}
              isRowEditable={true}
              isRowDeletable={isUserAllowedToDelete}
              onEditRow={editRow}
              onDeleteRow={onDelete}
              onApprove={onApprove}
              onRemoveApproval={onRemoveApproval}
              onLock={askForConfirmation}
              itemStatus={
                row.find((field) => field.name === "status")?.value || ""
              }
            />
          </>
        ) : (
          <StyledTableCell />
        )}
      </TableRow>
    </>
  );
};

export default memo(PayslipRowItem);
